var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('menusuperior',{attrs:{"titulo":"THEMIS","subtitulo":"Poder Judicial del Estado de Aguascalientes"}}),_vm._v(" "),_c('menuizquierda'),_vm._v(" "),_c('transition',{attrs:{"id":"contenidoDeLosSistemas","name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03773d04","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tablero/Plantilla.vue
// module id = null
// module chunks = 